let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7VJdQ"), load("jnk96")]).then(() => parcelRequire('5bnVm'));